module.exports = __webpack_public_path__ + "static/media/law_in_hand_2.136cd0b5.jpg";